import { observer } from 'mobx-react-lite';
import { TextField, Box } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import searchStore from '../../Mobx/SearchStore';

// פונקציה לזיהוי כיוון הטקסט לפי תו ראשון
const getDirection = (text) => {
    if (!text) return 'rtl';
    return /^[\u0590-\u05FF]/.test(text) ? 'rtl' : 'ltr';
};

const SearchInput = observer(() => {
    const [direction, setDirection] = useState('rtl');

    // פעולה מושהית ל-setText (חיפוש) לאחר 500ms
    const debouncedSetText = useMemo(
        () => debounce((value) => {
            searchStore.setText(value);
        }, 500),
        []
    );

    // פעולה מיידית לשינוי כיוון
    const handleChange = (e) => {
        const value = e.target.value;
        setDirection(getDirection(value));  // ← קורה מיד
        debouncedSetText(value);            // ← קורה אחרי 500ms
    };

    useEffect(() => {
        return () => {
            debouncedSetText.cancel();
        };
    }, [debouncedSetText]);

    return (
        <Box display="flex" justifyContent="center" mt={0}>
            <TextField
                fullWidth
                placeholder="הקלד לחיפוש..."
                defaultValue={searchStore.text}
                onChange={handleChange}
                variant="standard"
                autoComplete="off"
                inputMode="search"
                sx={{
                    mx: 2,
                    mt: 0.5,
                    maxWidth: 400,
                    backgroundColor: '#ffffff',      // רקע לבן/בהיר
                    borderRadius: '12px',            // פינות מעוגלות
                    boxShadow: '0 8px 24px rgba(0,0,0,0.35)', // צל מודגש יותר
                    transition: 'box-shadow 0.3s ease',
                }}
                InputProps={{
                    disableUnderline: true,
                    sx: {
                        px: 2,
                        height: 40,
                    },
                }}
                inputProps={{
                    dir: direction,
                    autoComplete: 'off',
                }}
            />
        </Box>
    );
});

export default SearchInput;
